import {LeaderboardEntry, LeaderboardsProvider, user} from '@wonderlandengine/uber-sdk';

export type LeaderboardOptions = {
    leaderboardId: string;
    serverUrl: string;
};

export class RotbLeaderboardsProvider implements LeaderboardsProvider {
    name = 'riseoftheblobs-leaderboards-provider';
    private _serverUrl: string;
    private _leaderboardId: string;

    constructor(options: LeaderboardOptions) {
        this._serverUrl = options.serverUrl;
        this._leaderboardId = options.leaderboardId;
    }

    async postScore(leaderboardId: string, score: number): Promise<boolean> {
        if (!user.isLoggedIn) {
            return false;
        }
        //     try {
        //         await user.requestLogin();
        //     } catch (e) {
        //         console.log(e);
        //         return false;
        //     }
        // }
        try {
            const newEntry = {name: user.user.name, score};
            // this.leaderboardData.push(newEntry); // Update local cache
            // // Sort leaderboardData in descending order
            // this.leaderboardData.sort((a, b) => b.score - a.score);
            const response = await fetch(
                `${this._serverUrl}/leaderboard/${leaderboardId ?? this._leaderboardId}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(newEntry),
                }
            );
            if (!response.ok) {
                console.error('Failed to save leaderboard entry:', response.statusText);
                return;
            }
        } catch (error) {
            console.error('Error saving leaderboard entry:', error);
        }
    }

    async getScores(leaderboardId: string, maxCount: number): Promise<LeaderboardEntry[]> {
        try {
            const response = await fetch(
                `${this._serverUrl}/leaderboard/${leaderboardId ?? this._leaderboardId}`
            );
            if (!response.ok) {
                console.error('Failed to load leaderboard:', response.statusText);
                return;
            }

            const json = (await response.json()) || {data: []};
            const entries: LeaderboardEntry[] = json.data.map((entry: any) => ({
                user: entry.id.split('___')[0], //TK: need to split the ID, maybe it's better to store the name?
                score: entry.score,
            }));
            return entries;
        } catch (error) {
            console.error('Error loading leaderboard:', error);
        }
    }
}
